import React from 'react'
import './LawyerStatus.scss'
const LawyerStatus = ({ status }) => {
  return <div className={`a-lawyerStatus -${status}`} />
}

export default LawyerStatus
